<template>
  <div :class="classes">
    <c-input-raw
      v-bind="$attrs"
      placeholder="Mínimo"
      :error="error"
      v-model="start"
      @input="onChange"
      @update:modelValue="onChange"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />

    <span class="text">e</span>

    <c-input-raw
      v-bind="$attrs"
      placeholder="Máximo"
      :error="error"
      v-model="end"
      @input="onChange"
      @update:modelValue="onChange"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />
  </div>
</template>

<script>
import CInputRaw from '@convenia/components/CInput/fragments/CInputRaw.vue'

export default {
  name: 'CInputRange',

  components: { CInputRaw },

  emits: [ 'input', 'update:modelValue', 'focus', 'blur' ],

  props: {
    value: {
      type: Array,
      default: () => ([ 0, 10 ])
    },

    error: Boolean
  },

  computed: {
    classes () {
      return [
        'c-input-range',
        {
          '-validation': this.error,
        }
      ]
    },
  },

  data: () => ({
    start: null,
    end: null,
  }),

  watch: {
    value: {
      handler (val) {
        if (Array.isArray(val)) {
          const [ start, end ] = val
          this.start = start
          this.end = end
        }
      },
      immediate: true,
    }
  },

  methods: {
    onChange () {
      this.$emit('input', [ this.start, this.end ])
    },

    focus () {
      try {
        this.$refs.input.$el.focus()
      } catch (e) { return e }
    }
  }
}
</script>

<style lang="scss">
.c-input-range {
  display: flex;
  align-items: center;

  & > .c-input-raw { width: 105px; }

  & > .text {
    margin: 0 15px;
    @include typo(h5, base-50);
  }
}
</style>
